// extracted by mini-css-extract-plugin
export default {"contentTitle":"Title_contentTitle__myo5P","border":"Title_border__JVUus","alingCenter":"Title_alingCenter__ak7Qr"};